import React, { useEffect, useState } from 'react'
import Banner from '../About Sections/Banner'
import Tab from './Tabes/Tab'
import { NavLink, useParams } from "react-router-dom";
import { BASE_URL } from '../../Components/Base_url/Base_Url'
import Services_ui from './Services_ui/Services_ui';

function Service() {
  const { slug } = useParams();
  const [SegmentD, setSegmentD] = useState([]);
  const [Serviceloading, setServiceLoading] = useState(true);
  const [Service, setService] = useState([]);
  const [serviceloading, setserviceloading] = useState(true);


  const getsegment = async () => {
    try {

      const url = `${BASE_URL}/segment/?slug=${slug}`

      const response = await fetch(url);
      const data = await response.json();
      if (data?.data) {
        console.log("GetSegment:", data.data);
        setSegmentD(data.data);
      }
    } catch (error) {
      console.error("Error fetching Service:", error);
    } finally {
      setServiceLoading(false);
    }
  }


  const fetchService = async () => {
    try {

      const url = `${BASE_URL}/zone/?segment_id=${slug}`

      const response = await fetch(url);
      const data = await response.json();
      if (data?.data) {
        setService(data.data);
      }
    } catch (error) {
      console.error("Error fetching Service:", error);
    } finally {
      setserviceloading(false);
    }
  };

  useEffect(() => {
    getsegment();
    fetchService();
  }, [slug]);

  console.log("slug", slug)
  console.log("Service", Service)

  return (
    <>

      {/* <h1 style={{ fontSize: "500px" }}>aman mangal</h1> */}
      <Banner SegmentD={SegmentD} Serviceloading={Serviceloading} slug={slug} />


      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12 text-center px-3 px-md-5 py-3">
            <h4 className='text-dark fw-bold'>{SegmentD && SegmentD.length > 0 ? SegmentD[0].extra : 'Call For Cabs'}</h4>
          </div>
        </div>

        {/* <Services_ui Service={Service} serviceloading={serviceloading} slug={SegmentD} /> */}

        <Services_ui Service={Service} serviceloading={serviceloading} slug={SegmentD} />

      </div>
      {/* <Tab /> */}


    </>
  )
}

export default Service